<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="7">
          <el-input placeholder="请输入内容" clearable @clear="searchUser" v-model="queryInfo.query">
            <el-button slot="append" icon="el-icon-search" @click="searchUser"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="dialogVisible = true">添加用户</el-button>
        </el-col>
      </el-row>
      <el-table :data="userlist" border stripe style="width: 100%" v-loading="loading">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="tip" label="备注"></el-table-column>
        <el-table-column label="权限">
          <template v-slot="scope">
            <el-tag v-if="scope.row.rights.indexOf('1')!==-1" type="info">用户管理</el-tag>
            <el-tag v-if="scope.row.rights.indexOf('2')!==-1" type="success">发布任务</el-tag>
            <el-tag v-if="scope.row.rights.indexOf('3')!==-1" type="warning">处理任务</el-tag>
            <el-tag v-if="scope.row.rights.indexOf('4')!==-1" type="warning">数据管理</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="状态" min-width="60">
          <template v-slot="scope">
            <el-switch v-model="scope.row.status" @change="userStateChanged(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <!-- 编辑用户 -->
          <template v-slot="scope">
            <el-button type="primary" @click="showEditDialog(scope.row.username)" size="mini">修改密码</el-button>
            <el-button type="primary" @click="showRightsDialog(scope.row.username)" size="mini">设置权限</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[1, 2, 5, 10]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加用户对话框 -->
    <el-dialog title="添加用户" :visible.sync="dialogVisible" width="50%" @close="addDialogClosed">
      <el-form
        :model="addUserForm"
        :rules="addUserFormRules"
        ref="addUserFormRef"
        label-width="70px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addUserForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addUserForm.password"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="tip">
          <el-input v-model="addUserForm.tip"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑用户对话框 -->
    <el-dialog title="修改密码" :visible.sync="editDialogVisible" width="30%" @close="editDialogClosed">
      <el-form
        :model="editUserForm"
        :rules="editUserFormRules"
        ref="editUserFormRef"
        label-width="70px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名">
          <el-input v-model="editUserForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpass">
          <el-input v-model="editUserForm.newpass"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUser">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设置权限对话框 -->
    <el-dialog
      title="设置用户权限"
      :visible.sync="setRightsDialogVisible"
      @close="setRightsDialogClosed"
      width="30%"
    >
      <el-checkbox
        :indeterminate="rightsDiag.isIndeterminate"
        v-model="rightsDiag.checkAll"
        @change="handleCheckAllChange"
      >全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="rightsDiag.checkedOptions" @change="handleCheckedOptionsChange">
        <el-checkbox
          class="cardiacCheckbox"
          v-for="option in rightsDiag.options"
          :label="option"
          :key="option"
        >{{option}}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer">
        <el-button @click="setRightsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyRights">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const rightsOptions = ["用户管理", "发布任务", "处理任务","数据管理"];
const rightsOptionsMap = { 用户管理: "1", 发布任务: "2", 处理任务: "3",数据管理:"4"};
const rightsOptionsMap2 = { "1": "用户管理", "2": "发布任务", "3": "处理任务","4":"数据管理" };

export default {
  data() {
    return {
      loading: false,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 5
      },
      userlist: [],
      total: 0,
      dialogVisible: false,
      editDialogVisible: false,
      addUserForm: {
        username: "",
        password: "",
        tip: ""
      },
      addUserFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            require: true,
            min: 5,
            max: 25,
            message: "用户名长度在 5 到 25 个字符",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            require: true,
            min: 5,
            max: 25,
            message: "密码长度在 5 到 25 个字符",
            trigger: "blur"
          }
        ],
        tip: [
          { required: false },
          {
            require: false,
            max: 10,
            message: "备注不能超过 20 个字符",
            trigger: "blur"
          }
        ]
      },
      editUserForm: {
        username: "",
        newpass: ""
      },
      editUserFormRules: {
        newpass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            require: true,
            min: 6,
            max: 15,
            message: "密码长度在 6 到 15 个字符",
            trigger: "blur"
          }
        ]
      },
      setRightsDialogVisible: false,
      rightsDiag: {
        userid: "",
        checkAll: false,
        checkedOptions: [],
        options: rightsOptions,
        isIndeterminate: false
      }
    };
  },
  methods: {
    async getUserList() {
      this.loading = true;
      const { data } = await this.$http.post("user/users", this.queryInfo);
      if (data.status === 100) {
        this.userlist = data.data.list;
        this.total = data.data.total;
        this.loading = false;
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.queryInfo.pagenum = 1;
      this.getUserList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getUserList();
    },
    async userStateChanged(userinfo) {
      const { data } = await this.$http.post("user/status", {
        username: userinfo.username,
        status: userinfo.status
      });
      if (data.status === 100) {
        this.$message({
          message: userinfo.status ? "用户激活" : "用户禁用",
          type: "success"
        });
      }
    },
    addDialogClosed() {
      this.$refs.addUserFormRef.resetFields();
    },
    addUser() {
      this.$refs.addUserFormRef.validate(async valid => {
        if (!valid) return;
        const { data } = await this.$http.post(
          "user/register",
          this.addUserForm
        );
        if (data.status === 100) {
          this.$message({
            message: data.data,
            type: "success"
          });
          this.dialogVisible = false;
          this.getUserList();
        }
      });
    },
    searchUser() {
      this.queryInfo.pagenum = 1;
      this.getUserList();
    },
    async showEditDialog(id) {
      this.editUserForm.username = id;
      this.editDialogVisible = true;
    },
    editDialogClosed() {
      this.$refs.editUserFormRef.resetFields();
    },
    editUser() {
      this.$refs.editUserFormRef.validate(async valid => {
        if (!valid) return;
        const { data } = await this.$http.post(
          "user/password",
          this.editUserForm
        );
        if (data.status === 100) {
          this.$message({
            message: data.data,
            type: "success"
          });
          this.editDialogVisible = false;
        }
      });
    },
    setRightsDialogClosed() {
      this.rightsDiag.checkAll = false;
      this.rightsDiag.checkedOptions = [];
      this.rightsDiag.isIndeterminate = false;
      this.rightsDiag.userid = "";
    },
    async showRightsDialog(id) {
      const { data } = await this.$http.get("user/previlege/" + id);
      if (data.status === 100) {
        var check = [];
        var rightslist = data.data;
        for (let i = 0; i < rightslist.length; i++) {
          check.push(rightsOptionsMap2[rightslist[i]]);
        }
        this.rightsDiag.checkedOptions = check;
        this.rightsDiag.checkAll =
          check.length === this.rightsDiag.options.length;
        this.rightsDiag.isIndeterminate =
          check.length > 0 && check.length < this.rightsDiag.options.length;

        this.rightsDiag.userid = id;
        this.setRightsDialogVisible = true;
      }
    },
    handleCheckAllChange(val) {
      this.rightsDiag.checkedOptions = val ? this.rightsDiag.options : [];
      this.rightsDiag.isIndeterminate = false;
    },
    handleCheckedOptionsChange(value) {
      let checkedCount = value.length;
      this.rightsDiag.checkAll =
        checkedCount === this.rightsDiag.options.length;
      this.rightsDiag.isIndeterminate =
        checkedCount > 0 && checkedCount < this.rightsDiag.options.length;
    },
    async modifyRights() {
      var rightsarr = [];
      for (let i = 0; i < this.rightsDiag.checkedOptions.length; i++) {
        rightsarr.push(rightsOptionsMap[this.rightsDiag.checkedOptions[i]]);
      }
      const { data } = await this.$http.post("user/previlege", {
        username: this.rightsDiag.userid,
        rights: rightsarr
      });
      if (data.status === 100) {
        this.$message({
          message: data.data,
          type: "success"
        });
        this.setRightsDialogVisible = false;
        this.getUserList();
      }
    }
  },
  created() {
    this.getUserList();
  }
};
</script>

<style lang="less" scoped></style>
